"use client";

import React from "react";
import { Facebook, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const address = "2800 TX Highway 114, Suite 200, Trophy Club, TX 76262";
  const phone = "(682) 800-4727";
  const email = "Elvira.Jasarevic@CrescentDPC.com";
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <section data-section-id="166454" id="footer" className="text-foreground pt-16 pb-8 border-t border-border !bg-[hsl(0,0%,100%)]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-6">
            <Link to="/HomePage">
              <img src="https://fair-mollusk.10web.cloud/wp-content/uploads/2026/04/Crescent-Logo.png" alt="Crescent Direct Primary Care Logo" className="w-auto !h-[50px]" />
            </Link>
            <div className="flex items-start gap-3 text-muted-foreground text-sm font-sans">
              <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
              <p className="leading-relaxed">2800 E. State Highway 114, Suite 200, Trophy Club, TX 76262<br /><span className="mt-2 block" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:97g1bu" data-ast-start="2274" data-ast-end="2472">Comprehensive primary care built on trust and transparency.</span></p>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-2xl font-serif tracking-tight text-primary">Practice Navigation</h3>
            <MenuProvider menu_id="43">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-2xl font-serif tracking-tight text-primary">Patient Care</h3>
            <ul className="space-y-4">
              <li>
                <Link to={`tel:${phone.replace(/\D/g, '')}`} className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors text-sm group font-sans"><div className="bg-muted p-2 rounded-full group-hover:bg-primary/10 transition-colors" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:hkxeee" data-ast-start="3189" data-ast-end="3363"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-4 text-primary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:gjmsk9" data-ast-start="3297" data-ast-end="3338"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg></div>(682) 800-4727</Link>
              </li>
              <li>
                <Link to={`mailto:${email}`} className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors text-sm group font-sans"><div className="bg-muted p-2 rounded-full group-hover:bg-primary/10 transition-colors" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:hkxeee" data-ast-start="4202" data-ast-end="4375"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail size-4 text-primary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:f9y45h" data-ast-start="4310" data-ast-end="4350"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg></div>elvira.jasarevic@crescentdpc.com</Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-2xl font-serif tracking-tight text-primary">Stay Connected</h3>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={social.label} data-index={i} variant="outline" size="icon" className="rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent transition-all duration-400 ease-out-expo" asChild>
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

        </div>

        {}
        <Separator className="my-10 bg-border" />
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground font-sans">
            &copy; {currentYear} Crescent Direct Primary Care. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="font-mono text-xs font-bold tracking-widest text-primary uppercase">
              HIPAA Compliant Care
            </span>
          </div>
        </div>
      </div>
    </section>;
}